//repack
const Repack = () => import("Modules/manufacturing/repack/views/Repack");
const RepackCreate = () => import("Modules/manufacturing/repack/views/RepackCreate");

// ROUTE OPTION - `pathToRegexpOptions: { strict: true }` makes trailing slashes fail to match path
export default {
    children: [
        {
            path: "repack",
            name: "repack",
            component: Repack,
            meta: {
                requiresAuth: true,
                title: "lang.packages",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["repack.read"],
            },
        },
        {
            path: "repack/create/:id(\\d+)",
            name: "repack_create",
            component: RepackCreate,
            meta: {
                requiresAuth: true,
                title: "lang.create_package",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["repack.read", "repack.create"],
            },
        },
    ],
};
